import { useTranslations } from 'next-intl'
import AddonsFetchFailure from './addonsFetchFailure'

const AddonsFetchFailureWrapper = () => {
    const t = useTranslations('itineraryPage.addons')
    return <AddonsFetchFailure t={t} />
}

export default AddonsFetchFailureWrapper
